export const PRODUCT_SELECT_HTML_BINDING = {
  productName: 'prod-name',
  productBlueprintName: 'prod-bp-name',
  badge: 'prod-badge',
  hasPerk: 'prod-hasperk',
  hasTrial: 'prod-hastrial',
  hasDiscount: 'prod-hasdiscount',
  durationCount: 'prod-duration-count',
  durationText: 'prod-duration-text',
  periodPrice: 'prod-periodprice',
  periodText: 'prod-period-text',
  perkPercent: 'prod-perk-percent',
  periodPricePerMonth: 'prod-calc-price-month',
  periodPriceBeforeDiscount: 'prod-price-before-discount',
  periodMonthlyPriceBeforeDiscount: 'prod-price-before-discount-monthly',
};

export const SELECTED_PRODUCT_HTML_BIDING = {
  productName: 'selectedprod-name',
  productOfferName: 'selectedprod-bp-name',
  hasPerk: 'selectedprod-hasperk',
  hasTrial: 'selectedprod-hastrial',
  hasDiscount: 'selectedprod-hasdiscount',
  durationTextFriendly: 'selectedprod-periodDurationFriendly',
  durationText: 'selectedprod-duration-text',
  durationCount: 'selectedprod-duration-count',
  periodPrice: 'selectedprod-periodprice',
  perkPercent: 'selectedprod-perk-percent',
  periodPricePerMonth: 'selectedprod-calc-price-month',
  periodPriceBeforeDiscount: 'selectedprod-price-before-discount',
  periodMonthlyPriceBeforeDiscount:
    'selectedprod-price-before-discount-monthly',
  comparativePrice: 'selectedprod-perk-comparativeprice',
  firstPeriodEndDate: 'selectedprod-firstperiod-end-date',
  firstPeriodLengthInDays: 'selectedprod-firstperiod-length-days',
  hasForcedCrossgrade: 'selectedprod-has-forced-crossgrade',
  crossgradePrice: 'selectedprod-forced-crossgrade-price',
  crossgradeDurationText: 'selectedprod-forced-crossgrade-duration-text',
  crossgradeStartOnMonth: 'selectedprod-forced-crossgrade-start-on-month',
};

export const PRODUCT_SELECT_ACTIONS_HTML_BINDING = {
  selectProduct: 'prod-select',
  selectProductWithRedirect: 'prod-select-redirect',
};

export const PURCHASE_PAGE_HTML_BINDING = {
  discountField: 'discount-field',
  discountAppliedSuccess: 'discount-applied-success',
};

export const PURCHASE_PAGE_ACTIONS_HTML_BINDING = {
  applyDiscount: 'apply-discount',
};
